/*! hotspots.js
    v0.1 (c) Mircea Piturca
    MIT License
*/
(function Hotspots(SD) {
  "use strict";

  var support = getSupport();
  var instances = nodeList("[data-hotspots-config]");
  var close = document.getElementById("hotspots-close");
  if (close)
    close.addEventListener("click", function () {
      var hotspots = gethotspots(getConfig(instances[0]));
      hotspots.filter(not(isCollapsed)).map(collapse);
    });
  instances.map(function (instance) {
    var config = Object.freeze(getConfig(instance));

    var publicAPI = {
      hotspots: function () {
        return gethotspots(config);
      },
      hotspot: gethotspot,
      select: select,
      deselect: deselect,
      config: config,
      init: init,
    };

    if (!SD[config.sectionId]) init(config);
    SD[config.sectionId] = publicAPI;

    return publicAPI;
  });

  // ******************************

  function init(config) {
    var hotspots = gethotspots(config);
    var triggers = pluck(hotspots, "trigger");

    triggers.map(function (element) {
      element.addEventListener("click", function triggerClick() {
        hotspotClick(hotspots, element.value);
      });
    });
  }

  function getConfig(instance) {
    return JSON.parse(instance.innerHTML);
  }

  function gethotspots(config) {
    return config.blocksId.map(gethotspot);
  }

  function gethotspot(id) {
    var host = document.getElementById("hotspot-" + id);

    return {
      id: id,
      trigger: host.querySelector("[data-hotspot-trigger]"),
      overlay: host.querySelector("[data-hotspot-overlay]"),
      markup: host.querySelector("[data-hotspot-markup]"),
      get collapsed() {
        return isCollapsed(this);
      },
    };
  }

  function hotspotClick(hotspots, id) {
    var isSelected = partial(idMatch, id);
    hotspots.filter(isSelected).map(toggle);
    hotspots.filter(not(isSelected)).filter(not(isCollapsed)).map(collapse);
  }

  function toggle(hotspot) {
    hotspot.collapsed ? expand(hotspot) : collapse(hotspot);
  }

  function expand(hotspot) {
    hotspot.overlay.innerHTML = hotspot.markup.textContent;
    hotspot.overlay.style.setProperty("--end-h", height(hotspot));
    hotspot.overlay.style.setProperty("--start-h", "0px");
    hotspot.trigger.setAttribute("aria-expanded", true);

    hotspot.overlay.addEventListener("animationend", function animationEndFn() {
      if(window.innerWidth < 990) {
        close.style.display = "block";
      }
      animationReset(hotspot.overlay, animationEndFn);
    });

    return hotspot;
  }

  function collapse(hotspot) {
    close.style.display = "none";
    hotspot.overlay.style.setProperty("--start-h", height(hotspot));
    hotspot.overlay.style.setProperty("--end-h", "0px");
    hotspot.trigger.setAttribute("aria-expanded", false);

    if (!support.customProperties) hotspot.overlay.innerHTML = "";

    hotspot.overlay.addEventListener("animationend", function animationEndFn() {
      animationReset(hotspot.overlay, animationEndFn);
      hotspot.overlay.innerHTML = "";
    });

    return hotspot;
  }

  function animationReset(element, callback) {
    element.removeAttribute("style");
    element.removeEventListener("animationend", callback);
  }

  function idMatch(id, hotspot) {
    return hotspot.id === id;
  }

  function isCollapsed(hotspot) {
    return attr("aria-expanded", hotspot.trigger) === "false";
  }

  function height(hotspot) {
    return px(hotspot.overlay.offsetHeight.toString());
  }

  function px(n) {
    return n + "px";
  }

  /* DOM */
  function attr(str, element) {
    return element.getAttribute(str);
  }

  function nodeList(str, root) {
    if (!root) root = document;
    var nodeList = root.querySelectorAll(str);
    return Array.prototype.slice.call(nodeList);
  }

  /* Fn */
  function not(predicate) {
    return function negated() {
      return !predicate.apply(undefined, arguments);
    };
  }

  function pluck(array, key) {
    return array.map(function (obj) {
      return obj[key];
    });
  }

  function partial(fn) {
    var slice = Array.prototype.slice;
    var args = slice.call(arguments, 1);
    return function () {
      return fn.apply(this, args.concat(slice.call(arguments, 0)));
    };
  }

  /* Support */
  function getSupport() {
    return {
      customProperties: window.CSS && CSS.supports("color", "var(--primary)"),
    };
  }

  /* Theme editor */
  function select(blockId) {
    return expand(gethotspot(blockId));
  }

  function deselect(blockId) {
    return collapse(gethotspot(blockId));
  }
})((window.SectionsDesign = window.SectionsDesign || {}));
